export const INDIVIDUALREPORTSLIST_SEARCH = 'INDIVIDUALREPORTSLIST_SEARCH';
export const INDIVIDUALREPORTSLIST_PAGE = 'INDIVIDUALREPORTSLIST_PAGE';
export const INDIVIDUALREPORTSLIST_STARTDATE = 'INDIVIDUALREPORTSLIST_STARTDATE';
export const INDIVIDUALREPORTSLIST_ENDDATE = 'INDIVIDUALREPORTSLIST_ENDDATE';
export const INDIVIDUALREPORTSLIST_CLUBID = 'INDIVIDUALREPORTSLIST_CLUBID';
export const INDIVIDUALREPORTSLIST_INDIVIDUALREPORTLABELID = 'INDIVIDUALREPORTSLIST_INDIVIDUALREPORTLABELID';
